import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PageData } from '@core/bean/page-data';

@Injectable({
  providedIn: 'root'
})
export class IndicatorsService extends BaseService{
  HEADER_NAME_TOTALCOUNT = 'X-Total-Count';
  private sysLoginAllUrl = 'api/sup-ass/sys-logic-all';//获取系统计算考核方法

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return "api/sup-ass";
  }

  getData(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data ='?'+data.slice(1);
    return new Observable((observable) => {
      this.http.get(`api/dict-item/search-code/${data}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

  getSysLogicAll():Observable<any> {
    const url = `${this.sysLoginAllUrl}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getSysLogicAll`)),
      catchError(this.handleError<any>(`getSysLogicAll`))
    );
  }
}
